import React from "react";
import ToggleGroup from "../ToggleGroup";
import { formatPrice } from "../../../utils/formatPrice";

// Themed cakes only offer 4 or 6 layers - not the contiguous 4/5/6 range.
const THEMED_LAYER_OPTIONS = [4, 6];

// Themed cakes: full-cake only, no format/pieces/weight/sheet controls - just
// the layer count (hidden entirely when product.noLayers is set, e.g. Car
// Theme Cake).
const ThemedCakeOptions = ({ layersApply, selectedLayers, onLayersChange, MIN_LAYERS, effectiveLayerPrice }) => (
    <>
        {layersApply && (
            <ToggleGroup
                label="Layers"
                options={THEMED_LAYER_OPTIONS}
                selected={selectedLayers}
                onSelect={onLayersChange}
                formatOption={(v) => (v === MIN_LAYERS ? `${v} Layers` : `${v} Layers (+${formatPrice((v - MIN_LAYERS) * effectiveLayerPrice)})`)}
            />
        )}
    </>
);

export default ThemedCakeOptions;
